module.exports = __webpack_public_path__ + "img/location.5e7cf5f3.svg";